import { useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useOutletContext, useParams, useSearchParams } from "react-router-dom";
import { getVendorClientList, VendorClientConnectionsHeaders } from "./Helper";
import { TablePagination } from "@mui/material";
import {ArrowBack as ArrowBackIcon} from "@mui/icons-material";
import Swal from "sweetalert2";
import { useQueryParams } from "../../../hooks";


function VendorClientConnectionList() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [vendorClientConnections, setVendorClientConnections] = useState([]);
  const [vendorPage, setVendorPage] = useState(0);
  const [vendorLimit, setVendorLimit] = useState(9);
  const [vendorTotal, setVendorTotal] = useState(0);
  const context = useOutletContext();
  const { vendorid } = useParams();
  const navigate = useNavigate();
  const {getParam} = useQueryParams();

  const connectionTitle = searchParams.get('connectiontitle')

  const fetchConnectedClients = async (vendorid, connectionTitle) => {
    try {
      const res = await getVendorClientList(vendorid, connectionTitle === 'VENDOR' ? "PARTNER" : connectionTitle);
      setVendorClientConnections(res?.data?.partner_details?.rows);
      setVendorTotal(res?.data?.partner_details?.rows?.length)
    } catch (error) {
      if(!error?.response?.data?.success) {
        navigate(`/UserManager/Vendor?page=${getParam("page")}&pageSize=${getParam("pageSize")}`);
        Swal.fire("Info", error?.response?.data?.msg , "info")
      }
    }
  }

  useEffect(() => {
    context(["User Manager", "Vendor", connectionTitle === 'VENDOR' ? "Vendor Connections" : connectionTitle === 'CLIENT' ? 'Client Connections' : 'Resources Connections']);
    fetchConnectedClients(vendorid, connectionTitle);
  }, [vendorid, connectionTitle])

  const renderVendorClientConnectionsHeaders = (item, index) => (
    <th scope="col" class="py-3 px-6 uppercase" key={index}>{item}</th>
  )

  const handleChangePage = (event, newPage) => {
    getVendorClientList(vendorid, connectionTitle).then((res) => {
      setVendorClientConnections(res?.data?.partner_details?.rows);
    })
    setVendorPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setVendorLimit(parseInt(event.target.value, 10));
    setVendorPage(0);
    getVendorClientList(vendorid, connectionTitle).then((res) => {
      setVendorClientConnections(res?.data?.partner_details?.rows);
    })
  };

  return (
    <div className="p-5 shadow-md bg-white">
      <div className="flex flex-col items-start">
        <button className="flex rounded-lg p-2 mb-4 bg-[#2EBAA3] text-[#fff]" onClick={()=> navigate(`/UserManager/Vendor?page=${getParam("page")}&pageSize=${getParam("pageSize")}`)}>
          <ArrowBackIcon sx={{marginRight: "8px"}} />
          Go Back
        </button>
        <h1 className="col-span-5 text-lg uppercase tracking-wider font-bold pb-4" style={{ color: "#2EBAA3" }}>{connectionTitle} List</h1>
      </div>
      <table class="w-full text-sm text-left text-gray-500">
        <thead class="text-xs text-gray-700 uppercase bg-gray-50">
          <tr>{VendorClientConnectionsHeaders.map(renderVendorClientConnectionsHeaders)}</tr>
        </thead>
        <tbody>
          {vendorClientConnections?.map((vend, index) => {
            return (
              <tr class="bg-white border-b ">
                <th
                  scope="row"
                  class="py-4 px-6 font-medium text-gray-900 whitespace-nowrap cursor-pointer"
                  // onClick={(e) => viewCustomer(e, customer._id)}
                  key={index}
                >
                  {index + 1}
                </th>
                <td class="py-4 px-6">
                  <a href={`${process.env.REACT_APP_BASE_FE_URL}/${connectionTitle === 'CLIENT' ? vend?.client?.username : connectionTitle === 'VENDOR' ? vend?.vendor2?.username : vend?.consultant?.username}`} target="_blank">{connectionTitle === 'CLIENT' ? vend?.client?.company : connectionTitle === 'VENDOR' ? vend?.vendor2?.company : `${vend?.consultant?.firstName} ${vend?.consultant?.lastName}`}</a>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <TablePagination
        component="div"
        count={vendorTotal}
        page={vendorPage}
        onPageChange={handleChangePage}
        rowsPerPage={vendorLimit}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[2, 5, 10, 25, 50, 100]}
      />
    </div>
  )
}

export default VendorClientConnectionList;